import React, { useState, useEffect } from 'react';
import AccountMenu from '../components/menu_component';
import SchoolTable from '../components/schools_component';
import Students from '../components/students_new';
import { useAccessContext } from '../contexts/access_context';
import Senteces_Students from '../components/sentences_component';
import DefaultPage from '../components/default';
import Dashboard from './dashboard';

const Main: React.FC = () => {
  const { access_data } = useAccessContext();
  const [selectedPage, setSelectedPage] = useState<React.ReactNode>(null);
  const [loading, setLoading] = useState(true); // Estado para indicar carregamento

  const handleMenuSelect = (page: string) => {
    setLoading(true);
    setSelectedPage(MenuOption[page] || <DefaultPage onSelect={handleMenuSelect} />);
    setTimeout(() => setLoading(false), 100);
  };
  
  const MenuOption: Record<string, React.ReactNode> = {
    Escolas: <SchoolTable />,
    Alunos: <Students school={access_data} />,
    Questionário: <Senteces_Students />,
    Page_Default: <DefaultPage onSelect={handleMenuSelect} />,
    Dashboard: <Dashboard />
  };

  useEffect(() => {
    setLoading(false); // Quando o componente monta, o carregamento termina
    switch (access_data.profile) {
      case "students":
        setSelectedPage(MenuOption['Page_Default']);
        break;
      case "master":
        setSelectedPage(MenuOption['Escolas']);
        break;
      default:
        setSelectedPage(MenuOption['Alunos']);
    }
  }, []);

  return (
    <>
      <AccountMenu onSelect={handleMenuSelect} />
      {loading ? <p>Carregando...</p> : selectedPage}
    </>
  );
};

export default Main;
